import { useState, useEffect } from 'react';
import { assemblyService } from 'services/api';

// Aviso NO bloqueante: cambiar coeficientes de unidades (o borrar torres, que se llevan
// sus unidades) con una asamblea en curso mueve el cuórum y los resultados en vivo. Solo informa; si la consulta
// falla no se muestra nada (el aviso no debe estorbar la pantalla). La página solo
// lo monta cuando hay un conjunto en alcance (si no, mezclaría todos los conjuntos).
export default function AsambleaEnCursoAviso({ propertyId, enTorres = false }) {
  const [asambleas, setAsambleas] = useState([]);

  useEffect(() => {
    let vivo = true;
    assemblyService.getAll({ status: 'en_progreso', property_id: propertyId || undefined, limit: 20 })
      .then(r => { if (vivo) setAsambleas(r.data.data || []); })
      .catch(() => { if (vivo) setAsambleas([]); });
    return () => { vivo = false; };
  }, [propertyId]);

  if (!asambleas.length) return null;
  return (
    <div className="alert alert-warning" role="status">
      ⚠️ Hay {asambleas.length === 1 ? 'una asamblea en curso' : `${asambleas.length} asambleas en curso`} en este conjunto.
      {enTorres
        ? 'Si borras una torre se borran sus unidades, y el cuórum y los resultados se recalculan en vivo.'
        : 'Si cambias coeficientes, el cuórum y los resultados se recalculan en vivo.'}
    </div>
  );
}
